import React from 'react'
import './Article.css'

const article = () => {
  return (
    <div>
      
    </div>
  )
}

export default article
